import { render, staticRenderFns } from "./Translate.vue?vue&type=template&id=5b75f2fc&scoped=true&"
import script from "./Translate.vue?vue&type=script&lang=js&"
export * from "./Translate.vue?vue&type=script&lang=js&"
import style0 from "./Translate.vue?vue&type=style&index=0&id=5b75f2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b75f2fc",
  null
  
)

export default component.exports